import styled from 'styled-components';

const gencatWidth = '120px';
const percentageSize = 1.3;

export const Nav = styled.nav`
  background: #333333;
  color: #d4d4d4;
  width: 100%;
  z-index: 9;
`;

export const NavContainer = styled.div`
  display: inline-flex;
  position: relative;
  height: 40px;
  width: 100%;
`;

export const MenuIconWrapper = styled.div`
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ selected }) => (selected ? '#febf00' : '#c00000')};
  cursor: pointer;
  color: #fff;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 20 * percentageSize : 20)}px;
`;

export const GencatWrapper = styled.div`
  height: ${(props) => props.navHeight};
  position: absolute;
  left: 80px;
  top: 6px;
  box-sizing: border-box;
  display: flex;
  @media screen and (max-width: 768px) {
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const GencatIconWrapper = styled.div`
  height: ${(props) => props.navHeight};
  /* width: ${gencatWidth}; */
  padding-left: 0px;
  padding-right: 0px;
  display: flex;
  vertical-align: middle;
  margin: auto;
`;

export const GencatIcon = styled.img`
  cursor: pointer;
  margin-right: 15px;
  width: 80px;
  height: 65%;
  filter: brightness(0) invert(1);
`;

export const HipermapaTextWrapper = styled.div`
  height: ${(props) => props.navHeight};
  max-width: calc(50vw - (40px + 80px + 40px) - (450px / 2) - 10px);
  align-items: center;
  display: flex;
  border-left: 2px solid white;
  @media screen and (max-width: 1400px) {
    max-width: calc(100vw - (40px + 80px + 40px) - 730px);
  }
  @media screen and (max-width: 1280px) {
    max-width: calc(100vw - (40px + 80px + 40px) - 530px);
  }
  @media screen and (max-width: 768px) {
    max-width: calc(100vw - (40px + 80px + 40px) - 40px);
  }
`;

export const HipermapaText = styled.p`
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 15px;
  padding-right: 15px;
  color: #fff;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 18 * percentageSize : 18)}px;
  @media screen and (max-width: 768px) {
    padding-right: 0px;
  }
`;

export const SearcherContainer = styled.div`
  height: ${(props) => props.navHeight};
  text-align: center;
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  width: 500px;
  @media screen and (max-width: 1400px) {
    margin-right: 290px;
  }
  @media screen and (max-width: 1280px) {
    margin-right: 40px;
    width: 450px;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const SearcherWrapper = styled.div``;

export const DeleteSearchIconButton = styled.button`
  background-color: white;
  border: 0px;
  border-radius: 0;
  cursor: ${({ text }) => (text ? 'pointer' : 'default')}!important;

  :hover {
    filter: hue-rotate(90deg);
  }
`;
export const DeleteSearchIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 22 * percentageSize : 22,
  height: props.fontSizeEnabled ? 22 * percentageSize : 22
}))`
  fill: '#333333';
  cursor: pointer;
`;

export const GraySearchButton = styled.button`
  background-color: white;
  color: gray;
  border: 0px;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
`;

export const SearcherInput = styled.input`
  height: 28px;
  vertical-align: middle;
  border: 0px;
  border-radius: 0px;
  display: flex;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  flex: 1;

  &:focus {
    border: 0;
    border-color: transparent;
    box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 0%);
  }
`;

export const TreeSearchButtonWrapper = styled.div``;

export const TreeSearchButton = styled.button`
  background: ${({ selected }) => (selected ? '#febf00' : '#c00000')};
  color: ${({ selected }) => (selected ? '#333333' : 'white')};
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid white;
  margin: auto;
  width: 50px;
  border-radius: 0px 3px 3px 0px;
`;

export const SvgSearchButton = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  fill: props.selected ? '#333333' : 'white'
}))``;

export const ToolButtonsContainer = styled.div`
  height: ${(props) => props.navHeight};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  right: 0;
  margin-right: 2px;
  box-sizing: border-box;
  @media screen and (max-width: 768px) {
    margin: auto;
  }
`;

export const ToolButtonWrapper = styled.div`
  display: flex;
  text-align: center;
  margin: auto;
  height: ${(props) => props.navHeight};
  width: 100%;
  padding: 0px 4px;
  @media screen and (max-width: 1280px) {
    display: none;
  }
`;

export const ToolButton = styled.button`
  border-radius: 50%;
  background-color: ${({ selected }) => (selected ? '#febf00' : '#c00000')};
  height: 32px;
  padding: 0;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  border: 0;
  margin: auto;
  cursor: pointer;
  z-index: 5;
`;

export const ToolButtonHref = styled.a`
  border-radius: 50%;
  background-color: ${({ selected }) => (selected ? '#febf00' : '#c00000')};
  height: 28px;
  text-align: center;
  vertical-align: middle;
  border: 0;
  margin: auto;
  width: 28px;
`;

export const ToolButtonHrefIcon = styled.img`
  vertical-align: middle;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  filter: ${({ selected }) => (selected ? 'none' : 'brightness(0) invert(1)')};
`;

export const ToolButtonIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 20 * percentageSize : 20,
  height: props.fontSizeEnabled ? 20 * percentageSize : 20
}))`
  fill: ${({ selected }) => (selected ? '#333333' : 'white')};
`;
export const ToolButtonIconPrint = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 248.059 248.059',
  width: props.fontSizeEnabled ? 20 * percentageSize : 20,
  height: props.fontSizeEnabled ? 20 * percentageSize : 20
}))`
  fill: ${({ selected }) => (selected ? '#333333' : 'white')};
`;

export const FullScreenButton = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 19 * percentageSize : 19,
  height: props.fontSizeEnabled ? 19 * percentageSize : 19
}))`
  fill: ${({ selected }) => (selected ? '#333333' : 'white')};
`;
export const ToolButtonIconShare = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 20 * percentageSize : 20,
  height: props.fontSizeEnabled ? 20 * percentageSize : 22
}))`
  fill: ${({ selected }) => (selected ? '#333333' : 'white')};
`;
export const ToolButtonIconLoad = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 20 * percentageSize : 20,
  height: props.fontSizeEnabled ? 20 * percentageSize : 20
}))`
  fill: ${({ selected }) => (selected ? '#333333' : 'white')};
`;

/* export const ToolButtonIcon = styled.img`
  vertical-align: middle;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  height: 16px;
  width: 16px;
  filter: ${({ selected }) => (selected ? 'none' : 'brightness(0) invert(1)')};
`; */

export const ModalAccesibilityContainer = styled.div`
  width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 140 : 120)}px;
  height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 110 : 90)}px;
  position: absolute;
  z-index: ${({ open }) => (!open ? '1' : '25')};
  align-items: center;
  background-color: #333333cc;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  font-weight: 200;
  align-items: center;
  justify-content: center;
  transition: cubic-bezier(0.6, 0.04, 0.98, 0.335);
  right: 80px;
  color: #fff;
  padding: 5px;
  display: ${({ open }) => (open ? 'block' : 'none')};
  @media screen and (max-width: 1280px) {
    top: 40px;
    right: 150px;
    border-top-right-radius: 0;
    background-color: #333333cc;
    height: 70px;
  }
`;

export const ModalAccesibilityForm = styled.div``;

export const AccesibilityTitleLabel = styled.label`
  font-weight: 500;

  @media screen and (max-width: 1280px) {
    display: none;
  }
`;

export const TamanyLletraLabel = styled.label`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
`;

export const AccesibilityContrast = styled.div``;

export const ContrastLabel = styled.label`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
`;

export const AccesibilityFontSize = styled.div``;

export const AccesibilityRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  vertical-align: middle;
  margin: 5px;
`;

export const Switch = styled.label`
  position: relative;
  display: flex;
  width: 42px;
  height: 10px;
  cursor: pointer;
`;

export const SwitchSpan = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  &::before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    background-color: #c00000;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    vertical-align: center;
    -webkit-transform: translateY(-4px) translateX(-2px);
    -ms-transform: translateY(-4px) translateX(-2px);
    transform: translateY(-4px) translateX(-2px);
    border-radius: 50%;
  }
`;

export const SwitchCB = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${SwitchSpan} {
  }

  &:focus + ${SwitchSpan} {
    box-shadow: 0 0 1px #2196f3;
  }

  &:checked + ${SwitchSpan}:before {
    -webkit-transform: translateX(28px) translateY(-4px);
    -ms-transform: translateX(28px) translateY(-4px);
    transform: translateX(28px) translateY(-4px);
    background-color: #f7c11e;
  }
`;

export const FormIcon = styled.img`
  vertical-align: middle;
  text-align: center;
  margin: auto;
  display: flex;
  filter: brightness(0) invert(1);
  width: auto;
  height: auto;
`;

export const MoreButton = styled.button`
  display: none;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);

  @media screen and (max-width: 1280px) {
    display: block;
    right: 0;
    background-color: transparent;
    border: 0;
    transform: translateY(-50%) scale(0.8);
  }
`;

export const MoreButtonIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  fill: 'white',
  width: props.fontSizeEnabled ? 30 * percentageSize : 30,
  height: props.fontSizeEnabled ? 30 * percentageSize : 30
}))``;

export const CollapsedNav = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: inline-flex;
    height: 40px;
    width: 100%;
    text-align: center;
    vertical-align: middle;
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    margin: auto;
    background-color: whitesmoke;
    padding: 10px;
    z-index: 25;
  }
`;

export const SpaceContainer = styled.div``;

export const ToolButtonsCollapsedContainer = styled.div`
  display: ${({ open }) => (open ? 'flex' : 'none')};

  @media screen and (max-width: 1280px) {
    width: 150px;
    /* height: 130px; */
    position: absolute;
    right: 0px;
    top: 40px;
    z-index: 25;
    align-items: center;
    background-color: #333333cc;
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
    font-weight: 200;
    align-items: center;
    justify-content: center;
    transition: cubic-bezier(0.6, 0.04, 0.98, 0.335);
    padding: 5px;
    color: white;
    text-align: left;
  }
`;

export const ToolButtonsCollapsedWrapper = styled.div``;

export const TBCul = styled.ul`
  list-style: none;
  padding: 8px;
  margin: 0px;
`;

export const TBCli = styled.li`
  display: inline-block;
  width: 100%;
  font-size: 0;
`;

export const TBCbtn = styled.button`
  background-color: transparent;
  border: 0px solid transparent;
  color: white;
  display: inline-block;
  text-align: left;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 15 * percentageSize : 15)}px;
  color: ${({ open }) => (open ? '#febf00' : 'white')};
  font-weight: ${({ open }) => (open ? 600 : 'normal')};
  :hover {
    color: #febf00;
  }
`;

export const TBCa = styled.a`
  color: white;
  text-decoration: none;
  :hover {
    color: #febf00;
  }
`;

export const ExportPDF = styled.button`
  width: 20px;
  height: 20px;
  background-color: red;
`;

export const AjudaModal = styled.div`
  width: 140px;
  position: absolute;
  z-index: 25;
  background-color: #333333cc;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  font-weight: 200;
  right: 0px;
  color: #fff;
  padding: 5px;
  @media screen and (max-width: 1280px) {
    top: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 152 : 119)}px;
    right: 150px;
    border-top-right-radius: 0;
    background-color: #333333cc;
    height: 80px;
  }
`;

export const AjudaModalText = styled.div`
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: transparent;
  color: white;
  :hover {
    text-decoration: underline;
  }
`;

export const InfoButton = styled.button`
  background: none;
  padding: 0;
  padding-right: 6px;
  display: flex;
  align-items: 'center';
  border: none;
`;
